// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Mtj65n {
  border: none;
  padding: 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  left: auto;
  width: 480px;
  height: 100vh;
  min-height: 100vh;
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s) 0 0 var(--radius-s);
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  cursor: default;
  z-index: 1300;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: var(--spacing-1);
  }
  &::-webkit-scrollbar-thumb {
    width: var(--spacing-1);
    background-color: var(--text-neutral-subtle);
    border-radius: var(--radius-m);
  }
}

.Mtj65n:focus {
  outline: none;
}

.Mtj65n::backdrop {
  background: var(--neutral-dark-opacity-50);
}

.Mtj65n[open] {
  margin: 0;
  height: 100vh;
  min-height: 100vh;
}

.FOT6M5 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding-top: var(--spacing-3);
  background: var(--surface-neutral-white);
}

.WrQb2V {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  width: 100%;
  background: var(--surface-neutral-white);
  padding: var(--spacing-3);
}

.fLIdia {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 36px;
  gap: var(--spacing-1);
}

.aT5JaV {
  font-family: var(--font-family-base);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.h3nhfM {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
}

.qt6fuG {
  width: 16px;
  height: 16px;
}

.nuQO7B {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: var(--spacing-3);
  padding-bottom: var(--spacing-3);
  gap: var(--spacing-2);
}

.OEHiPx {
  width: 32px;
  height: 32px;
}

.Bir94x {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0);
}

.HfdaYI {
  font-family: var(--font-family-base);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.H09iZ3 {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: var(--spacing-3);
  padding-bottom: var(--spacing-3);
  gap: var(--spacing-2);
  border-top: 1px solid var(--surface-neutral-subtle);
}

.i7nhiw {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-2);
}

.Pktyd1 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  text-align: left;
}

.jTfh0Z {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  text-align: right;
}

.IQAwBX {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: var(--spacing-2);
}

.Ut_XBr {
  width: 72px;
  height: 72px;
}

.g2Ff7j {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  text-align: center;
}

.A2WJEI {
  position: sticky;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-2);
  padding: var(--spacing-3);
  background: var(--surface-neutral-white);
}

.XnAs6H {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/Receipt/Receipt.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,wCAAwC;EACxC,kDAAkD;EAClD,2CAA2C;EAC3C,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,4CAA4C;IAC5C,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,OAAO;EACP,WAAW;EACX,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,gCAAgC;EAChC,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb","sourcesContent":[".modal {\n  border: none;\n  padding: 0;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: auto;\n  width: 480px;\n  height: 100vh;\n  min-height: 100vh;\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s) 0 0 var(--radius-s);\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);\n  box-sizing: border-box;\n  cursor: default;\n  z-index: 1300;\n  overflow-y: auto;\n  &::-webkit-scrollbar {\n    width: var(--spacing-1);\n  }\n  &::-webkit-scrollbar-thumb {\n    width: var(--spacing-1);\n    background-color: var(--text-neutral-subtle);\n    border-radius: var(--radius-m);\n  }\n}\n\n.modal:focus {\n  outline: none;\n}\n\n.modal::backdrop {\n  background: var(--neutral-dark-opacity-50);\n}\n\n.modal[open] {\n  margin: 0;\n  height: 100vh;\n  min-height: 100vh;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  height: 100%;\n  padding-top: var(--spacing-3);\n  background: var(--surface-neutral-white);\n}\n\n.body {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1;\n  width: 100%;\n  background: var(--surface-neutral-white);\n  padding: var(--spacing-3);\n}\n\n.header {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  height: 36px;\n  gap: var(--spacing-1);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n}\n\n.chevronLeft {\n  width: 16px;\n  height: 16px;\n}\n\n.hero {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding-top: var(--spacing-3);\n  padding-bottom: var(--spacing-3);\n  gap: var(--spacing-2);\n}\n\n.icon {\n  width: 32px;\n  height: 32px;\n}\n\n.amountWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0);\n}\n\n.amount {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding-top: var(--spacing-3);\n  padding-bottom: var(--spacing-3);\n  gap: var(--spacing-2);\n  border-top: 1px solid var(--surface-neutral-subtle);\n}\n\n.row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--spacing-2);\n}\n\n.label {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  text-align: left;\n}\n\n.value {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  text-align: right;\n}\n\n.errorWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  gap: var(--spacing-2);\n}\n\n.errorImage {\n  width: 72px;\n  height: 72px;\n}\n\n.errorText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  text-align: center;\n}\n\n.footer {\n  position: sticky;\n  bottom: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-2);\n  padding: var(--spacing-3);\n  background: var(--surface-neutral-white);\n}\n\n.button {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `Mtj65n`,
	"content": `FOT6M5`,
	"body": `WrQb2V`,
	"header": `fLIdia`,
	"title": `aT5JaV`,
	"closeButton": `h3nhfM`,
	"chevronLeft": `qt6fuG`,
	"hero": `nuQO7B`,
	"icon": `OEHiPx`,
	"amountWrapper": `Bir94x`,
	"amount": `HfdaYI`,
	"column": `H09iZ3`,
	"row": `i7nhiw`,
	"label": `Pktyd1`,
	"value": `jTfh0Z`,
	"errorWrapper": `IQAwBX`,
	"errorImage": `Ut_XBr`,
	"errorText": `g2Ff7j`,
	"footer": `A2WJEI`,
	"button": `XnAs6H`
};
module.exports = ___CSS_LOADER_EXPORT___;
